import dayjs from "dayjs";
import "dayjs/locale/es";

/**
 * Estados de frescura del monitoreo de salidas. El backend solo manda
 * timestamps; la clasificacion se hace aqui contra el `now` del servidor para
 * no depender del reloj del navegador.
 */

// Umbrales (minutos sin dato de geocerca en salidas en curso)
export const WARN_MIN = 10;
export const CRIT_MIN = 30;

export const REFRESH_SEC = 60;

export const META = {
  ok: { label: "Al día", dot: "#1aa251", bg: "#e3f6eb", fg: "#3d3d43" },
  late: { label: "Demorada", dot: "#f2b600", bg: "#fffae6", fg: "#997300" },
  crit: { label: "Crítica", dot: "#e5484d", bg: "#fcebec", fg: "#c4282d" },
  nodata: { label: "Sin salidas hoy", dot: "#9c9ca6", bg: "#f4f4f6", fg: "#5c5c64" },
};

export const ORDEN_ESTADOS = ["ok", "late", "crit", "nodata"];

/** Minutos transcurridos entre `fecha` y `now` (null si no hay fecha). */
export const minutosDesde = (fecha, now) => {
  if (!fecha) return null;
  return Math.max(0, dayjs(now).diff(dayjs(fecha), "minute"));
};

export const estadoPorMinutos = (min) => {
  if (min <= WARN_MIN) return "ok";
  if (min <= CRIT_MIN) return "late";
  return "crit";
};

/**
 * Estado de una ruta:
 * - con salidas en curso: por la frescura del ultimo checkpoint;
 * - sin salidas en curso y sin finalizadas: ninguna ha iniciado ("Sin salidas hoy");
 * - sin salidas en curso pero con finalizadas: no se espera ningun dato, esta al dia.
 */
export const estadoRuta = (ruta, now) => {
  if (ruta.en_curso > 0) {
    return estadoPorMinutos(minutosDesde(ruta.last_update, now) ?? 0);
  }
  return ruta.finalizadas > 0 ? "ok" : "nodata";
};

export const agoColor = (estado) => {
  if (estado === "crit") return META.crit.fg;
  if (estado === "late") return META.late.fg;
  return "#5c5c64";
};

export const agoTxt = (m) => {
  if (m === null || m === undefined) return "sin datos hoy";
  if (m < 1) return "ahora";
  if (m < 60) return `hace ${m} min`;
  const h = Math.floor(m / 60);
  const r = m % 60;
  return `hace ${h} h${r ? ` ${r} min` : ""}`;
};

/** HH:mm si es del mismo dia que `now`; si no, "Ayer HH:mm" o "DD/MM HH:mm". */
export const hora = (fecha, now) => {
  if (!fecha) return "—";
  const f = dayjs(fecha);
  const n = dayjs(now);
  if (f.isSame(n, "day")) return f.format("HH:mm");
  if (f.isSame(n.subtract(1, "day"), "day")) return `Ayer ${f.format("HH:mm")}`;
  return f.format("DD/MM HH:mm");
};

export const fechaLarga = (now) => dayjs(now).locale("es").format("dddd D MMM YYYY");

/** Busqueda sin distinguir mayusculas ni acentos. */
export const normaliza = (txt) =>
  String(txt ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();
